import { EMAIL_IS_REGISTERED_MESSAGE } from '../../consts'
import store from '../store'
import {
    EVENT_REGISTRATION,
    sendWebViewEvent,
} from '../../events-webview'
import { updateApiLanguageByStore } from '../../locales/language-setter'

const SET_AUTHED_USER = 'SET_AUTHED_USER'

function setAuthedUser(state, user, checkOnBoarding) {
    return Object.assign({}, state, {
        user: user,
        isOnBoardingCompletly: checkOnBoarding ? isOnboardingCompletlyFilled(user) : state.isOnBoardingCompletly,
    })
}

function logout(state) {
    return Object.assign({}, state, { user: null })
}

function logoutRedirect(state, page) {
    return {
        ...state.auth,
        logoutRedirectPage: page,
    }
}

/**
 * Return true, if user has completly successful filled OnBoarding (achievements, birthday, sports and finished)
 * @param {Object} user
 * @returns {boolean}
 */
function isOnboardingCompletlyFilled(user) {
    return !!user?.onBoarding?.data?.finished &&
        !!user?.achievements &&
        !!user?.birthday &&
        !!user?.sports
}

/**
 * Set correct error message to show
 *
 * @param state
 * @param error
 * @returns {any}
 */
export function setLoginError(state, error) {
    let message = ''

    switch (error) {
        case 'invalid_credentials':
            message = 'Neplatné přihlašovací údaje'
            break
        case 'too_much_invalid_credentials':
            message = 'Příliš mnoho neplatných přihlášení, opakujte akci později'
            break
        case 'email_is_registered':
            message = EMAIL_IS_REGISTERED_MESSAGE
            break
        default:
            message = 'Chyba přihlášení'
    }

    return Object.assign({}, state, { error: message })
}

function clearLoginError(state) {
    return Object.assign({}, state, { error: null })
}

function setStoreTokens(state, tokens) {
    return {
        ...state,
        storeTokens: tokens,
    }
}

function setCognitoStoreTokens(state, tokens) {
    return {
        ...state,
        cognitoStoreTokens: tokens,
    }
}

function setCognitoUserAttributes(state, attributes) {
    return {
        ...state,
        cognitoUserAttributes: attributes,
    }
}

function toggleFetchingAuthedUser(state, inFlight) {
    return {
        ...state,
        fetchingAuthedUser: inFlight,
    }
}

function setEmailIsRegisteredMessage(state, message) {
    return {
        ...state,
        emailIsRegisteredMessage: message,
    }
}

/**
 * Set busy aws
 *
 * @param {Object} state
 * @param {boolean} busy
 * @return {{busyAWS: *}}
 */
function setBusyAWS(state, busy) {
    return {
        ...state,
        busyAWS: busy,
    }
}

export default function (state = [], action) {
    switch (action.type) {
        case 'SET_AUTHED_USER': return setAuthedUser(state, action.user, action.checkOnBoarding)

        case 'LOGOUT': return logout(state)

        case 'SET_LOGOUT_REDIRECT': return logoutRedirect(state, action.page)

        case 'SET_LOGIN_ERROR': return setLoginError(state, action.error)

        case 'CLEAR_LOGIN_ERROR': return clearLoginError(state)

        case 'SET_STORE_TOKENS': return setStoreTokens(state, action.tokens)

        case 'SET_COGNITO_STORE_TOKENS': return setCognitoStoreTokens(state, action.tokens)

        case 'SET_COGNITO_USER_ATTRIBUTES': return setCognitoUserAttributes(state, action.attributes)

        case 'TOGGLE_FETCHING_AUTHED_USER': return toggleFetchingAuthedUser(state, action.inFlight)

        case 'SET_EMAIL_IS_REGISTERED_MESSAGE': return setEmailIsRegisteredMessage(state, action.message)

        case 'SET_BUSY_AWS': return setBusyAWS(state, action.busy)

        default: return state
    }
}

/**
 * Submit webview event with logged user credentials
 * @param {Object} data
 * @param {{ email, password }|null} loginCredentials
 */
export const submitWebViewEventWithUserData = (loginCredentials = null) => {
    const auth = store.getState().auth
    const tokens = auth.storeTokens || auth.tokens
    const authedUser = auth.user

    const eventData = {
        close: true,
        data: {
            user: authedUser,
            tokens: tokens,
            loginCredentials: loginCredentials,
        },
    }

    sendWebViewEvent(EVENT_REGISTRATION, eventData)
}

/**
 * Save logged user tokens
 * @param {Object} data
 */
export const saveLoggedUserTokens = data => {
    const { access_token: accessToken } = data

    localStorage.removeItem('sportnect.tokens')
    localStorage.setItem('sportnect.tokens', JSON.stringify(data))

    window.axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`

    updateApiLanguageByStore()
}

/**
 * Get logged user from API
 * @returns {Promise<any>}
 */
export const getLoggedUser = () => (
    window.axios.get(`${window.APP_CONFIG.REACT_APP_API_URL}api/logged-user?include=links,onBoarding,sports.relationships,sports.locations,achievements,sfnData`)
        .then(({ data }) => {
            store.dispatch({
                type: SET_AUTHED_USER,
                user: data.data,
                checkOnBoarding: true,
            })
            return new Promise(resolve => resolve(data.data))
        })
)

/**
 * Possible logged with types
 * @typedef {'email' | 'facebook'} LoggedWithTypes
 */

/**
 * Save user into local storage
 * @param {Object} user
 * @param {LoggedWithTypes} loggedWith
 */
export const saveUserIntoLocalStorage = (user, loggedWith) => {
    const loggedUser = {
        loggedWith,
        user,
    }

    localStorage.removeItem('loggedUser')
    localStorage.setItem('loggedUser', JSON.stringify(loggedUser))
}
